/* eslint-disable no-param-reassign */
import { Promise as BluebirdPromise } from 'bluebird'
import {
  getLocalPreferences,
  setLocalPreferences,
} from 'services/local-preferences'
import {
  fromJS,
  List,
  Map,
} from 'immutable'
import _toString from 'lodash/toString'
import _get from 'lodash/get'

const LOCAL_STORAGE_KEY = 'inboundTracking'
const INBOUND_TRACKING_QUERY_UTM_VARS = List([
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_campaign',
  'utm_content',
  'utm_rainbow',
  'utm_platcamp',
  'ch',
  'gclid',
])
const REFERRAL_TRACKING_QUERY_VARS = List([
  'sourceId',
  'source',
  'rfd',
])

const EVERFLOW_TRACKING_QUERY_VARS = List([
  'ef_txn',
  'transaction_id',
  'oid',
  'affid',
])

const EVERFLOW_TRACKING_VARS = List([
  'transactionId',
  'offerId',
  'affiliateId',
])

const INBOUND_TRACKING_CI_VARS = List(['ci_type', 'ci_id'])
const INBOUND_TRACKING_SCARAB_VARS = List(['sc_src', 'sc_llid'])
const INBOUND_TRACKING_GCLID_VARS = List(['gclid'])
const INBOUND_TRACKING_QUERY_VARS = INBOUND_TRACKING_QUERY_UTM_VARS.concat(
  List(['cid', 'siteID', 'chan'])
    .concat(INBOUND_TRACKING_CI_VARS)
    .concat(REFERRAL_TRACKING_QUERY_VARS)
    .concat(INBOUND_TRACKING_SCARAB_VARS)
    .concat(INBOUND_TRACKING_GCLID_VARS)
    .concat(EVERFLOW_TRACKING_QUERY_VARS),
)

export function parseQuery (query, timestamp = new Date()) {
  return fromJS(query || {})
    .filter((v, k) => INBOUND_TRACKING_QUERY_VARS.includes(k))
    .withMutations((mutateQuery) => {
      if (containsUtm(mutateQuery     .setIn(['campaigns', 'processing'], false)
        .setIn(['campaigns', 'error'], error)
    }
    case actions.AMBASSADORS_SET_UPCOMING_CAMPAIGNS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['upcomingCampaigns', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_UPCOMING_CAMPAIGNS: {
      const { data, error } = payload
      return state.setIn(['upcomingCampaigns', 'data'], fromJS(data))
        .setIn(['upcomingCampaigns', 'processing'], false)
        .setIn(['upcomingCampaigns', 'error'], error)
    }
    case actions.AMBASSADORS_SET_SIGNUPS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['signups', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_SIGNUPS: {
      const { data, error } = payload
      return state.set('signups', fromJS(data))
        .setIn(['signups', 'processing'], false)
        .setIn(['signups', 'error'], error)
    }
    case actions.AMBASSADORS_SET_CAMPAIGN_DETAILS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['campaignDetails', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_CAMPAIGN_DETAILS: {
      const { data, error } = payload
      return state.setIn(['campaignDetails', 'data'], fromJS(data))
        .setIn(['campaignDetails', 'processing'], false)
        .setIn(['campaignDetails', 'error'], error)
    }

    default:
      return state
  }
}
